/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import EnvironmentModel from 'cio/models/environment';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';

type SelectItem = {
  model: EnvironmentModel;
  label: string;
  value: string;
  classes?: string;
};

interface EnvironmentDropdownItemArgs {
  item?: SelectItem;
  option?: SelectItem;
}

export default class EnvironmentDropdownItem extends Component<EnvironmentDropdownItemArgs> {
  @service environment!: EnvironmentService;

  get actualItem() {
    return this.args.item ?? this.args.option;
  }

  get isCurrentEnvironment() {
    return String(this.actualItem?.value) === String(this.environment.current.id);
  }
}
